import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { KeyboardEvent } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { MINIMUM_SEARCH_TERM_LENGTH } from "../../../constants/global";
import { useVrsTranslationState } from "../../../context/AppContext/AppContext";
import { styled } from "@mui/material/styles";
import { myWhiteShade0 } from "../../../constants/colors";

const RootContainer = styled("div")({
  display: "flex",
  alignItems: "center",
});

const IconButtonStyled = styled(IconButton)({
  padding: 10,
});

const ActiveOutlinedInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => !['useDefault'].includes(prop.toString()),
})<{ useDefault?: boolean }>(({ useDefault }) => (({theme}) => ({
  padding: theme.spacing(0, 0.625),
  ...(useDefault && {
    backgroundColor: myWhiteShade0
  })
})));


interface PlantSearchInputProps {
  searchTerm: string;
  onChange: (event) => void;
  className?: string;
  onSubmitSearch: (text: string, target: any) => void;
}

function PlantSearchInput({
  searchTerm,
  onChange,
  className,
  onSubmitSearch,
}: PlantSearchInputProps) {
  const { _T } = useVrsTranslationState();
  const submitSearchHandler = (event): void => {
    if (searchTerm.length >= MINIMUM_SEARCH_TERM_LENGTH) {
      onSubmitSearch(searchTerm, event.target);
    }
  };

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      submitSearchHandler(event);
    }
  };

  return (
    <RootContainer
      className={className || ""}
    >
      <ActiveOutlinedInput
        placeholder={_T("Search")}
        id="side-search-input"
        value={searchTerm}
        onChange={onChange}
        onKeyDown={onKeyDown}
        endAdornment={
          <InputAdornment position="end">
            <IconButtonStyled
              type="submit"
              aria-label="search"
              disabled={searchTerm.length < MINIMUM_SEARCH_TERM_LENGTH}
              onClick={submitSearchHandler}
            >
              <SearchIcon data-testid="SearchIcon" />
            </IconButtonStyled>
          </InputAdornment>
        }
      />
    </RootContainer>
  );
}

PlantSearchInput.displayName = "PlantSearchInput";

export { PlantSearchInput };
